// we do not offer offset accounts for fixed only loan application
export const showOffsetAccount = (interestType) => {
  return interestType !== 'fixed'
}
